import { UrlParamsType } from '@appTypes/urlParamsType';
import T from './carTerms';

export const ELBILGUIDE_ADDITIONAL_FILTERS: UrlParamsType['filter'] = {
  [T.FUEL_CATEGORIES]: [T.ELECTRIC],
};

// API returns trailer-hitch options as boolean-ish strings; the entry with name '1'
// represents the "has trailer hitch" option (it's the only one the UI renders).
export const TRAILER_HITCH_PRESENT_OPTION_NAME = '1';
